// ==============================|| OVERRIDES - INPUT BASE ||============================== //

export default function InputBase(theme) {
	return {
		MuiInputBase: {
			styleOverrides: {
				root: {
					MuiFilledInput: {
						disabled: {
							backgroundColor: 'red',
						},
						root: {
							'& .Mui-disabled': {
								backgroundColor: 'red',
								color: theme.palette.primary[800],
								WebkitTextFillColor: 'initial!important',
							},
						},
						'& .Mui-disabled': {
							backgroundColor: 'red',
							color: theme.palette.primary[800],
							WebkitTextFillColor: 'initial!important',
						},
					},
					'& .MuiFilledInput-root': {
						
						'& .Mui-disabled': {
							backgroundColor: 'red',
							color: theme.palette.primary[800],
							WebkitTextFillColor: 'initial!important',
						},
						
					}
				},
				sizeSmall: {}
			}
		}
	}
}
